<template>
  <div class="index" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 class="animated fadeInUp">我们的<span>伙伴</span></h3>
      <div @click="goNext()" class="button-bg animated flipInX" v-bind:style="{backgroundImage:'url(' + button_img + ')'}">
          点击查看
      </div>
      <img class="index-bottom animated fadeInUp" src="https://cdn.hanlandglobal.com/h5-partner-bg.png" />
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_img from '../assets/image/button-bg.png'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      button_img
    }
  },
  mounted(){

  },
  methods:{
    goNext:function(){
      this.$router.push('/partner2')
    }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  padding-top:13.6vh;
  animation-duration: 2s;
  span{
    font-size: 0.72rem;
  }
}
.index-bottom{
  width: 100%;
  height: 5.2rem;
  position: absolute;
  left: 0;
  bottom: 0;
  animation-duration: 1.5s;
}
.button-bg{
  width: 2rem;
  height: 0.62rem;
  animation-duration: 0.5s;
  animation-delay: 1s; 
  background-repeat: no-repeat;
  background-size: 2rem 0.62rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.32rem;
  line-height: 0.62rem;
  margin-top: 1.34rem;
  font-weight: 700;
  font-family: SourceHan;
}
</style>
